import { Expose } from 'class-transformer';
import { Model } from './Model';

export enum IdeaState {
	Draft          = 1,
	Rising         = 2,
	OnFloor        = 3,
	ApprovedPillar = 5,
	Archived       = 6,
	Withdrawn      = 7,
}

export class Idea extends Model {
	private _organizationId: string | null = null;
	@Expose()
	set organizationId(v: string | null) { this._organizationId = v; }
	get organizationId(): string | null { return this._organizationId; }

	private _sortOrder = 0;
	@Expose()
	set sortOrder(v: number) { this._sortOrder = v; }
	get sortOrder(): number { return this._sortOrder; }

	private _createdByAccountId: string | null = null;
	@Expose()
	set createdByAccountId(v: string | null) { this._createdByAccountId = v; }
	get createdByAccountId(): string | null { return this._createdByAccountId; }

	private _state: IdeaState = IdeaState.Draft;
	@Expose()
	set state(v: IdeaState) { this._state = v; }
	get state(): IdeaState { return this._state; }

	private _createdAt: Date | null = null;
	@Expose()
	set createdAt(v: Date | string | null) { this._createdAt = v ? new Date(v as string) : null; }
	get createdAt(): Date | null { return this._createdAt; }

	private _isDeleted = false;
	@Expose()
	set isDeleted(v: boolean) { this._isDeleted = v; }
	get isDeleted(): boolean { return this._isDeleted; }

	constructor(json: any = null) {
		super(json);
		if (json) {
			this.originalJson = json;
		}
	}
}

export class IdeaVersion extends Model {
	private _ideaId: string | null = null;
	@Expose()
	set ideaId(v: string | null) { this._ideaId = v; }
	get ideaId(): string | null { return this._ideaId; }

	private _result: number | null = null;
	@Expose()
	set result(v: number | null) { this._result = v; }
	get result(): number | null { return this._result; }

	private _title: string | null = null;
	@Expose()
	set title(v: string | null) { this._title = v; }
	get title(): string | null { return this._title; }

	private _proposal: string | null = null;
	@Expose()
	set proposal(v: string | null) { this._proposal = v; }
	get proposal(): string | null { return this._proposal; }

	private _problemGoal: string | null = null;
	@Expose()
	set problemGoal(v: string | null) { this._problemGoal = v; }
	get problemGoal(): string | null { return this._problemGoal; }

	private _reasoning: string | null = null;
	@Expose()
	set reasoning(v: string | null) { this._reasoning = v; }
	get reasoning(): string | null { return this._reasoning; }

	private _authoredBy: string | null = null;
	@Expose()
	set authoredBy(v: string | null) { this._authoredBy = v; }
	get authoredBy(): string | null { return this._authoredBy; }

	private _createdAtVersion: Date | null = null;
	@Expose()
	set createdAtVersion(v: Date | string | null) { this._createdAtVersion = v ? new Date(v as string) : null; }
	get createdAtVersion(): Date | null { return this._createdAtVersion; }

	constructor(json: any = null) {
		super(json);
		if (json) {
			this.originalJson = json;
		}
	}
}

export interface IdeaWithVersion {
	idea: Idea;
	version: IdeaVersion | null;
	hasContributed?: boolean;
	hasObjected?: boolean;
	hasVoted?: boolean;
	risingScore?: number;
	/** True when the idea is an ApprovedPillar surfaced due to fresh open objections */
	isAddendum?: boolean;
}
